// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1qzHE","right":"styles_right__WGI-r"};